import { SanityAuthor } from "@/types/sanityPost";
import { Box, Stack, Typography, alpha } from "@mui/material";
import React, { FC } from "react";
import { SanityImage } from "../SanityImage";
import { Styles } from "@/theme/theme.type";

export const AuthorBlock: FC<AuthorBlockProps> = ({
  author: { name, title, bio, _rawImage }
}) => {
  const styles = {
    root: {
      mt: { xs: 5, sm: 10 },
      display: "grid",
      gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
      alignItems: "center",
      p: { xs: 3, sm: 5 },
      borderRadius: 4,
      gap: 5,
      bgcolor: ({ palette }) => alpha(palette.primary.main, 0.08)
    },
    name: { fontSize: "1rem", lineHeight: 1.5, fontWeight: 700, mt: 2 },
    title: {
      fontSize: "0.75rem",
      lineHeight: 1
    },
    bio: {
      fontSize: { xs: "0.75rem", sm: "0.875rem" },
      lineHeight: { xs: 1.35, sm: 1.4 }
    }
  } satisfies Styles;

  return (
    <Box sx={styles.root}>
      <Stack sx={{ textAlign: "center" }} alignItems="center">
        <SanityImage
          style={{
            width: 80,
            height: 80,
            borderRadius: "50%",
            overflow: "hidden"
          }}
          loading="lazy"
          imageAssetId={_rawImage}
          alt={title ?? ""}
        />
        <Typography sx={styles.name}>{name}</Typography>
        <Typography color="textSecondary" sx={styles.title}>
          {title}
        </Typography>
      </Stack>
      <Typography color="textSecondary" sx={styles.bio}>
        {bio}
      </Typography>
    </Box>
  );
};

export interface AuthorBlockProps {
  author: SanityAuthor;
}
